import {ProductInterface} from "../../interfaces/product/ProductInterface";
import BrandInfo from "./BrandInfo";
import {useState} from "react";
import {Modal} from "react-bootstrap";

export default function TechDoc({product}: { product: ProductInterface }) {
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string>("");
    const additionalParams = product.additional_params;

    // Helper function to get current timestamp for cache busting
    const getTimestamp = () => Date.now();

    // Helper function to resize image URL
    const resizeImage = (url: string, size: string) => {
        return url.replace(/catalog-source/, `catalog-resize/${size}`);
    };

    // Helper function to add base URL if needed
    const getFullImageUrl = (url: string) => {
        if (!url) return "";
        return url.startsWith('http') ? url : `https://www.pride.ru${url}`;
    };

    // Handle image click to open in modal
    const handleImageClick = (imageUrl: string) => {
        setSelectedImage(imageUrl);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedImage("");
    };

    return (
        <div className="flex-column flex-lg-row gap-4 fade justify-content-between prod-pane active show">
            <div className="d-flex flex-column prod-pane__left ">
                <div className="tabsBox_tab nbt-tab nbt-tab-docs ">
                    <div className="tabsBox_offset bootstrap">
                        <div className="tabsBox_doc d-flex ">
                            {/* Release Image Section */}
                            {additionalParams?.release_image && (
                                <div className="text-center" style={{margin: '10px'}}>
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleImageClick(getFullImageUrl(additionalParams.release_image) + `?${getTimestamp()}`);
                                        }}
                                        style={{cursor: 'pointer'}}
                                    >
                                        <img
                                            style={{border: '1px solid silver'}}
                                            src={getFullImageUrl(resizeImage(additionalParams.release_image, '600x600')) + `?${getTimestamp()}`}
                                            alt="Release"
                                        />
                                    </a>
                                    {additionalParams.release_path && (
                                        <div className="text-center" style={{marginTop: '10px'}}>
                                            <a
                                                href={getFullImageUrl(additionalParams.release_path) + `?${getTimestamp()}`}
                                                target="_blank"
                                                className={'t-orange'}
                                                rel="noopener noreferrer"
                                            >
                                                скачать релиз
                                            </a>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Detailing Image Section */}
                            {additionalParams?.detailing_image && (
                                <div className="text-center" style={{margin: '10px'}}>
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleImageClick(getFullImageUrl(additionalParams.detailing_image) + `?${getTimestamp()}`);
                                        }}
                                        style={{cursor: 'pointer'}}
                                    >
                                        <img
                                            style={{border: '1px solid silver'}}
                                            src={getFullImageUrl(resizeImage(additionalParams.detailing_image, '600x600')) + `?${getTimestamp()}`}
                                            alt="Detailing"
                                        />
                                    </a>
                                    {additionalParams.detailing_path && (
                                        <div className="text-center" style={{marginTop: '10px'}}>
                                            <a
                                                href={getFullImageUrl(additionalParams.detailing_path) + `?${getTimestamp()}`}
                                                target="_blank"
                                                className={'t-orange'}
                                                rel="noopener noreferrer"
                                            >
                                                скачать деталировку
                                            </a>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Instruction Images Section */}
                            {additionalParams?.images?.instruction && additionalParams.images.instruction.length > 0 && (
                                <div className="text-center" style={{margin: '10px'}}>
                                    {additionalParams.images.instruction.map((img, index) => (
                                        <a
                                            key={index}
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleImageClick(getFullImageUrl(img) + `?${getTimestamp()}`);
                                            }}
                                            style={{cursor: 'pointer'}}
                                        >
                                            <img
                                                style={{border: '1px solid silver'}}
                                                src={getFullImageUrl(resizeImage(img, '600x600'))}
                                                alt={`Instruction ${index + 1}`}
                                            />
                                            <br/>
                                        </a>
                                    ))}
                                    {additionalParams.instruction_path && (
                                        <div className="text-center" style={{marginTop: '10px'}}>
                                            <a
                                                href={getFullImageUrl(additionalParams.instruction_path) + `?uid=${getTimestamp()}`}
                                                target="_blank"
                                                className={'t-orange'}
                                                rel="noopener noreferrer"
                                            >
                                                скачать инструкцию
                                            </a>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Other Images Section */}
                            {additionalParams?.images?.other && additionalParams.images.other.length > 0 && (
                                <div className="text-center" style={{margin: '10px'}}>
                                    {additionalParams.images.other.map((img, index) => (
                                        <div key={index}>
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleImageClick(getFullImageUrl(resizeImage(img, '1200x1200')) + `?${getTimestamp()}`);
                                                }}
                                                className={'t-orange'}
                                            >
                                                <img
                                                    style={{border: '1px solid silver'}}
                                                    src={getFullImageUrl(resizeImage(img, '600x600'))}
                                                    alt={`Other ${index + 1}`}
                                                />
                                            </a>
                                            <div>&nbsp;</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <BrandInfo product={product}/>



            {/* Image Modal */}
            <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{product.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt="Full size"
                            style={{width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain'}}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
}